export const chatLabels = {
  confirm: {
    en: 'Confirm',
    nl: 'Bevestig',
    fr: 'Confirmer',
  },
  view_options: {
    en: 'View options',
    nl: 'Bekijk opties',
    fr: 'Voir les options',
  },
  multi_select_hint: {
    en: 'Reply with the numbers of your choices (e.g. 1, 3)',
    nl: 'Antwoord met de nummers van je keuzes (bijv. 1, 3)',
    fr: 'Répondez avec les numéros de vos choix (par ex. 1, 3)',
  },
  in_progress: {
    en: 'One moment, thinking this through…',
    nl: 'Even denken…',
    fr: 'Un instant, je réfléchis…',
  },
  something_went_wrong: {
    en: 'Something went wrong. Please try again.',
    nl: 'Er ging iets mis. Probeer het opnieuw.',
    fr: "Une erreur s'est produite. Réessayez.",
  },
  /*
   * What Wundo says itself when a shared file could not be used, one line per
   * reason. `{files}` is a list of quoted names, or a count when the channel
   * gave no names; the colon keeps each line correct for one file or many.
   */
  attachment_notice_too_many: {
    en: "I only looked at the first {max} files. I didn't read these: {files}.",
    nl: 'Ik heb enkel de eerste {max} bestanden bekeken. Deze heb ik niet gelezen: {files}.',
    fr: "Je n'ai regardé que les {max} premiers fichiers. Je n'ai pas lu ceux-ci : {files}.",
  },
  attachment_notice_too_large: {
    en: 'Too large for me to read: {files}. A file can be up to {file_limit}, an image up to {image_limit}.',
    nl: 'Te groot om te lezen: {files}. Een bestand mag tot {file_limit} groot zijn, een afbeelding tot {image_limit}.',
    fr: "Trop volumineux pour que je le lise : {files}. Un fichier peut faire jusqu'à {file_limit}, une image jusqu'à {image_limit}.",
  },
  attachment_notice_unsupported: {
    en: "I can't read this kind of file: {files}. I can read PDFs, Word and PowerPoint documents, images and plain text.",
    nl: "Dit soort bestand kan ik niet lezen: {files}. Ik lees pdf's, Word- en PowerPoint-documenten, afbeeldingen en gewone tekst.",
    fr: 'Je ne sais pas lire ce type de fichier : {files}. Je lis les PDF, les documents Word et PowerPoint, les images et le texte brut.',
  },
  attachment_notice_conversion_failed: {
    en: "I couldn't open this file this time: {files}. Try sending it again, or send it as a PDF.",
    nl: 'Ik kon dit bestand deze keer niet openen: {files}. Probeer het opnieuw, of stuur het als pdf.',
    fr: "Je n'ai pas pu ouvrir ce fichier cette fois : {files}. Réessayez, ou envoyez-le en PDF.",
  },
  attachment_notice_link_only: {
    en: "I can't open a file shared as a OneDrive or SharePoint link: {files}. Attach the file itself with the paperclip, or paste the text.",
    nl: 'Een bestand dat als OneDrive- of SharePoint-link gedeeld is, kan ik niet openen: {files}. Voeg het bestand zelf toe met de paperclip, of plak de tekst.',
    fr: 'Je ne peux pas ouvrir un fichier partagé comme lien OneDrive ou SharePoint : {files}. Joignez le fichier lui-même avec le trombone, ou collez le texte.',
  },
  attachment_notice_oversized: {
    en: 'Too large for me to read in this conversation: {files}. Feel free to send a smaller version.',
    nl: 'Te groot om in dit gesprek te lezen: {files}. Stuur gerust een kleinere versie.',
    fr: 'Trop volumineux pour que je le lise dans cette conversation : {files}. Envoyez une version plus petite si vous le souhaitez.',
  },
  attachment_notice_trimmed: {
    en: 'Together with the other files, this was too much to read: {files}. Send it separately if you need it.',
    nl: 'Samen met de andere bestanden was dit te veel om te lezen: {files}. Stuur het apart als je het nodig hebt.',
    fr: "Avec les autres fichiers, c'était trop à lire : {files}. Envoyez-le séparément si vous en avez besoin.",
  },
  attachment_notice_unreadable: {
    en: "I couldn't read this file, so I'm leaving it out: {files}.",
    nl: 'Ik kon dit bestand niet lezen en laat het verder weg: {files}.',
    fr: "Je n'ai pas pu lire ce fichier, je le laisse donc de côté : {files}.",
  },
  attachment_notice_files_one: {
    en: '1 file',
    nl: '1 bestand',
    fr: '1 fichier',
  },
  attachment_notice_files_many: {
    en: '{count} files',
    nl: '{count} bestanden',
    fr: '{count} fichiers',
  },
} as const satisfies Record<string, Record<string, string>>;
